// extracted by mini-css-extract-plugin
export default {"addNoteInput":"NoteInput_addNoteInput__HgFIw","noteInput":"NoteInput_noteInput__b+qr4","addNoteButton":"NoteInput_addNoteButton__rKm4a"};